<template>
  <reaction-button
    type="subscribe"
    variant="dark"
    icon-reacted="fas fa-check"
    icon-unreacted="fas fa-rss"
    :id="id"
    :to="to"
  />
</template>
<script>
import VueTypes from 'vue-types'

import ReactionButton from './ReactionButton'

export default {
  name: 'SubscribeButton',

  components: {
    ReactionButton
  },

  props: {
    to: VueTypes.string.isRequired,
    id: VueTypes.oneOfType([
      VueTypes.string,
      VueTypes.integer
    ]).isRequired
  }
}
</script>
